import script from "./SvgBase.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgBase.vue?vue&type=script&setup=true&lang=js"

import "./SvgBase.vue?vue&type=style&index=0&id=f241c318&scoped=true&lang=css"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f241c318"]])

export default __exports__